(() => {
  "use strict";

  if (window.__popupBehaviorFixesInitialized) return;
  window.__popupBehaviorFixesInitialized = true;

  const DIALOG_SELECTOR = "dialog[data-close-on-outside]";
  const OPEN_DIALOG_SELECTOR = "dialog[data-close-on-outside][open]:not([inert])";
  const CONTENT_SELECTOR = "[data-modal-body], .popup-promo__inner, .small-newsletter, .drawer__inner, .product-modal__content";

  const getOpenDialogs = () => Array.from(document.querySelectorAll(OPEN_DIALOG_SELECTOR));

  const closeDialog = (dialog) => {
    const host = dialog.closest("popup-component, popup-newsletter");

    if (host && typeof host.popupClose === "function") {
      host.popupClose();
      return;
    }

    const closeButton = dialog.querySelector("[data-popup-close]");
    if (closeButton) {
      closeButton.click();
      return;
    }

    if (typeof dialog.close === "function") {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
      dialog.setAttribute("inert", "");
      dialog.setAttribute("aria-hidden", "true");
    }
  };

  const unlockScrollForOpenNewsletterPopup = () => {
    const hasOpenNewsletterPopup = document.querySelector("popup-newsletter dialog[open]:not([inert])");

    if (hasOpenNewsletterPopup && document.documentElement.hasAttribute("data-scroll-locked")) {
      document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
    }
  };

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest("[data-popup-open]")) return;

      getOpenDialogs().forEach((dialog) => {
        const content = dialog.querySelector(CONTENT_SELECTOR);
        if (!content) return;

        if (!content.contains(target)) {
          closeDialog(dialog);
        }
      });

      unlockScrollForOpenNewsletterPopup();
    },
    true
  );

  const observer = new MutationObserver(() => {
    unlockScrollForOpenNewsletterPopup();
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-scroll-locked"],
    subtree: false,
  });

  document.querySelectorAll(DIALOG_SELECTOR).forEach((dialog) => {
    observer.observe(dialog, {
      attributes: true,
      attributeFilter: ["open", "inert", "closing"],
    });
  });

  window.addEventListener("load", unlockScrollForOpenNewsletterPopup);
})();
